import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f84ab44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notfound" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "404", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "PAGE NOT FOUND", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { computed } from 'vue';
import { useInfo } from '@/store';

export default /*#__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

_useCssVars(_ctx => ({
  "0bc33758": (_unref(bg).pc),
  "79e07f87": (_unref(bg).mobile),
  "02fdcb9e": (_unref(spotlight).pc),
  "42cf4de0": (_unref(spotlight).mobile),
  "6af4482b": (_unref(textBg).pc),
  "74b2224c": (_unref(textBg).mobile)
}))

const { getImg } = useInfo();
const bg = computed(() => ({
  pc: `url(${getImg('404_pc_bg')})`,
  mobile: `url(${getImg('404_mobile_bg')})`,
}));
const spotlight = computed(() => ({
  pc: `url(${getImg('404_pc_spotlight')})`,
  mobile: `url(${getImg('404_mobile_spotlight')})`,
}));
const textBg = computed(() => ({
  pc: `url(${getImg('404_pc_text_bg')})`,
  mobile: `url(${getImg('404_mobile_text_bg')})`,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
}
}

})